import LooseItemDetails from "./looseItemDetails.container";

export default LooseItemDetails;
